import { writable } from "svelte/store";
export const currentSelectionStore = writable({ clusterIndex: null, topicIndex: null });
export const setCurrentSelection = (clusterIndex, topicIndex) => {
    currentSelectionStore.set({ clusterIndex, topicIndex });
};
